// Entry point. A short Sales Order link (<app>/s/<code>, sent on WhatsApp) only
// opens the PDF — a tiny page, so it is quick on the client's phone. Everything
// else starts the app.
const short = location.pathname.match(/^\/s\/([A-Za-z0-9]{8})\/?$/);
if (short) import('./share-open.js').then((m) => m.openSharedLink(short[1]));
else import('./app.js');
